import { ControlFacet } from '../models/controls/ControlFacet';
import { IFaceted } from '../models/Facet';

/**
 * @public
 */
export interface IItemDetailsRowProps {
    itemKey: string;
}

/**
 * @public
 */
export interface IItemDetailsRowOverrides {
    rowData: IFaceted;
}

/**
 * @public
 */
export const itemDetailsRowControl: ControlFacet<IItemDetailsRowProps, IItemDetailsRowOverrides> =
    new ControlFacet('itemDetailsRowControl');